export default __webpack_public_path__ + "static/media/MCM.a2fd7a45.png";